import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Haptics, ImpactStyle } from '@capacitor/haptics';

export const isNative = () => Capacitor.isNativePlatform();
export const getPlatform = () => Capacitor.getPlatform(); // 'android' | 'ios' | 'web'

/** Sesuaikan status bar dengan dark mode. Aman dipanggil di web (no-op). */
export async function syncStatusBar(isDark: boolean) {
  if (!isNative()) return;
  try {
    await StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.setStyle({ style: isDark ? Style.Dark : Style.Light });
    await StatusBar.setBackgroundColor({ color: isDark ? '#111827' : '#ffffff' });
  } catch (e) {
    console.log('StatusBar sync skipped:', e);
  }
}

/** Getaran halus saat mencentang sholat. Aman di web (no-op). */
export async function tapFeedback() {
  if (!isNative()) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {
    /* abaikan */
  }
}
